import PropTypes from 'prop-types';
import { Route, Routes } from 'react-router-dom';

// Third-parties.
import Helmet from 'react-helmet';

// Components.
import Breadcrumb from "../../../container/breadcrumb";
import DatabaseTypeTrail from "../../../container/breadcrumb/DatabaseTypeTrail";
import ConditionalRender from "../../../helpers/ConditionalRender";
import HeaderActions from "../../../container/header_actions";
import List from "./List";
import Details from "./Details";

function DatabaseStatistics(props: { toggleMenu: Function }) {

    return (
        <div id="content">

            <Helmet>
                <title>Statistics - DBmarlin</title>
                <meta name="description" content="Collect Database Statistics"/>
            </Helmet>

            {/* Heading */}
            <div id="top-header-wrapper" className="row row-cols-lg-3 row-cols-sm-1 row-cols-md-2">
                <Breadcrumb heading="Statistics">
                    {[<DatabaseTypeTrail key="database-statistics-trail" section="Statistics"
                                         sectionPath="/admin/database-statistics"/>]}
                </Breadcrumb>
               <HeaderActions toggleMenu={props.toggleMenu}/>
            </div>

            <div className="loader">
                <ConditionalRender if={false}>
                    <div className="bar"/>
                </ConditionalRender>
            </div>

            <div className="row row-cols-1">
                <Routes>
                    <Route path="/:actionId/:instanceId"
                           element={<Details />}/>
                    <Route path="/" element={<List/>}/>
                </Routes>
            </div>

        </div>
    );
}

DatabaseStatistics.propTypes = {
    toggleMenu: PropTypes.func.isRequired
};

export default DatabaseStatistics;
